export default "__VITE_ASSET__DrbYYcuh__"